import { Box, Typography, RadioGroup, FormControlLabel, Radio, FormControl } from '@mui/material';
import CustomersApiService from 'api/CustomersApiService';
import { Layout } from 'components';
import useApi from 'hooks/useApi';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { RouteComponentProps } from 'react-router-dom';
import { useSelector } from 'store/hooks';
import Customer from 'types/entities/Customer';
import { ActionDescriptor } from 'types/enums/ActionDescriptor';

const DashboardNotification: React.FC<RouteComponentProps> = ({ match }) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, value: string) => {
    console.log('valuess', value);
    setValue(value);
    const dataToUpdate: Partial<Customer> = {
      client_connection: appState.customer?.client_connection,
      action_id: ActionDescriptor.TenantSaveModifications,
    };
    const res = makeCall(
      CustomersApiService.updateCustomer(appState.customer?.id as number, dataToUpdate),
      'Unable to save customer'
    );
  };
  const appState = useSelector((state) => state.app);
  const { makeCall } = useApi();
  const [t] = useTranslation();
  const [value, setValue] = React.useState<string>('real-time');

  return (
    <Layout name="Settings" path="/dashboard-notification">
      <Box sx={{ borderBottom: 2, borderColor: 'divider', marginBottom: 2 }}>
        <Typography variant="h2" sx={{ fontWeight: 700, mb: 1 }}>
          Dashboard Notifications
        </Typography>
        <Typography variant="body2" sx={{ marginBottom: 2 }}>
          We may send critical account notifications beyond your notification settings.
        </Typography>
      </Box>
      <FormControl component="fieldset" sx={{ marginBottom: 2 }}>
        <RadioGroup
          aria-label="notification-settings"
          name="notification-settings"
          value={value}
          onChange={handleChange}
        >
          <FormControlLabel value="real-time" control={<Radio />} label="Real-time notifications (Default)" />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            Receive every update the moment it happens so you never miss a thing.
          </Typography>
          <FormControlLabel value="minimal" control={<Radio />} label="Minimal notifications" />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            Get only the key updates that matter to keep you on track.
          </Typography>
          <FormControlLabel value="de-activate" control={<Radio />} label="De-activate notifications" />
          <Typography variant="body2" sx={{ marginBottom: 1 }}>
            Stay distraction-free with no alerts or reminders.
          </Typography>
        </RadioGroup>
      </FormControl>
    </Layout>
  );
};
export default DashboardNotification;
